const STATES = {
  NONE: '',
  UPLOADING: 'uploading',
  COMPLETE: 'complete',
};

const KINDS = {
  DRAG_TARGET: 'drag-target',
  BUTTON: 'button',
};

export { KINDS, STATES };
